// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qRB-3","placeholdersHeader":"styles_placeholdersHeader__21rLH","editorStyle":"styles_editorStyle__3tnDB","placeholdersBox":"styles_placeholdersBox__2k3Qd"};